/* eslint-disable camelcase */
export default class ActivationPost {
  constructor ({ name, dateFrom, dateTo, productMaxInventory, productPrice, product, stores }) {
    this.name = name
    this.start_date = dateFrom
    this.end_date = dateTo
    this.price = productPrice
    this.max_inventory = productMaxInventory
    this.product_id = product.id
    this.stores = stores.map(store => store.id)
  }
}



// WEBPACK FOOTER //
// ./src/app/activations/models/ActivationPost.js